// extracted by mini-css-extract-plugin
export var quillEditor = "_p8-1";
export var variable = "_p8-0";